
import { AppDialogHelper } from 'general/components/AppDialog';
import AppConfigs from 'general/constants/AppConfigs';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import { useEffect } from 'react';

// Hook này đảm bảo eKYC.js đã được load và cho phép bạn gọi EKYC
export function useEkyc() {
  useEffect(() => {
    // Kiểm tra xem script đã được load chưa
    if (!document.querySelector('#ekyc-script')) {
      const script = document.createElement('script');
      script.id = 'ekyc-script';
      script.src = `/eKYC.js?api_key=${process.env.REACT_APP_EKYC_API_KEY}&app_store=${AppConfigs.env.ekycAppstore}&play_store=${AppConfigs.env.ekycPlayStore}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  // Hàm start eKYC
  const startEkyc = (customData, onDone) => {
    if (typeof window !== 'undefined' && window.EKYC) {
      const EKYC = window.EKYC;

      const ekyc = new EKYC(
        'eKYC_div',
        'wss://ekyc.mdcsoftware.com.vn/ws',
        customData ?? 'no data',
        function (check_result) {
          try {
            const jsonResult = JSON.parse(check_result);
            console.log('Kết quả eKYC:', jsonResult);
            const result = jsonResult.Result;
            console.log('Result:', result);
            if (result && result === 'Success') {
              AppDialogHelper.show('Thành công', 'Vui lòng đợi phải hồi từ hệ thống. Xin cảm ơn!', [
                {
                  title: 'Đóng lại',
                  type: 'positive',
                  onClick: () => {
                    AppDialogHelper.hide();
                    if (onDone) onDone();
                  },
                },
              ]);
            }
          } catch (error) {
            ToastHelper.showError(
              Utils.getMessageError(error) || 'Có lỗi xảy ra trong quá trình xử lý kết quả eKYC.',
            );
          }
        },
      );

      ekyc.start();
    } else {
      console.error('EKYC chưa được load hoặc window.EKYC không tồn tại');
    }
  };

  return { startEkyc };
}
